/* Floodlight · ss-faq.js (content)
   FAQ page: topic filter, search over question + answer text, "nothing in this topic" and
   "no match" states, clear. Port of parts/25-views.js vFaq.
   Opening/closing single questions is core's accordion ([data-acc], ss-ui.js); this file only
   records what the visitor toggled so a search never re-opens a question they closed. */
(function () {
  if (window.SS_LOADED_faq) return;
  window.SS_LOADED_faq = true;

  function ready(type, init) {
    if (window.SS && typeof SS.sectionReady === 'function') return SS.sectionReady(type, init);
    var run = function () {
      Array.prototype.forEach.call(document.querySelectorAll('[data-section-type="' + type + '"]'), function (el) { init(el); });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    else run();
  }

  function fill(tpl, map) {
    return String(tpl || '').replace(/\{(\w+)\}/g, function (m, k) { return map[k] != null ? map[k] : m; });
  }

  function init(root) {
    if (!root || root.__ssFaq) return;
    var layout = root.querySelector('[data-faq]');
    if (!layout) return;
    root.__ssFaq = true;

    var input = root.querySelector('[data-faq-input]');
    var topics = Array.prototype.slice.call(root.querySelectorAll('[data-faq-topic]'));
    var notes = Array.prototype.slice.call(root.querySelectorAll('[data-faq-note]'));
    var other = root.querySelector('[data-faq-other]');
    var empty = root.querySelector('[data-faq-empty]');
    var otherLead = root.querySelector('[data-faq-other-lead]');
    var seeAll = root.querySelector('[data-faq-seeall]');
    var qEcho = root.querySelector('[data-faq-q]');
    var ds = layout.dataset;

    var groups = Array.prototype.map.call(root.querySelectorAll('[data-faq-group]'), function (g) {
      return {
        id: g.getAttribute('data-faq-group'),
        el: g,
        items: Array.prototype.map.call(g.querySelectorAll('[data-faq-item]'), function (it) {
          var btn = it.querySelector('.acc-btn');
          var body = btn ? document.getElementById(btn.getAttribute('aria-controls')) : null;
          return { el: it, btn: btn, body: body, key: btn ? btn.id : '', text: (it.textContent || '').replace(/\s+/g, ' ').toLowerCase() };
        })
      };
    });

    var state = { group: 'all', query: '', open: {} };
    groups.forEach(function (g) {
      g.items.forEach(function (it) {
        if (it.btn && it.btn.getAttribute('aria-expanded') === 'true') state.open[it.key] = true;
      });
    });

    function setOpen(it, open) {
      if (!it.btn || !it.body) return;
      var was = it.btn.getAttribute('aria-expanded') === 'true';
      if (was === open) return;
      it.btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      it.body.hidden = !open;
    }

    function render() {
      var q = state.query.trim().toLowerCase();
      var hits = 0;
      var shown = 0;
      groups.forEach(function (g) {
        var n = 0;
        g.items.forEach(function (it) {
          var match = !q || it.text.indexOf(q) >= 0;
          it.el.hidden = !match;
          if (!match) return;
          n++;
          var s = state.open[it.key];
          setOpen(it, s === false ? false : (!!s || q.length > 1));
        });
        hits += n;
        var show = n > 0 && (state.group === 'all' || state.group === g.id);
        g.el.hidden = !show;
        if (show) shown++;
      });
      var isOther = hits > 0 && shown === 0;
      var isEmpty = hits === 0;
      if (other) other.hidden = !isOther;
      if (empty) empty.hidden = !(isEmpty && q);
      if (isOther) {
        if (otherLead) otherLead.textContent = q ? fill(ds.otherLeadQ, { q: state.query.trim() }) : (ds.otherLeadNone || '');
        if (seeAll) seeAll.textContent = fill(hits === 1 ? ds.seeallOne : ds.seeallOther, { n: hits });
      }
      if (qEcho) qEcho.textContent = state.query.trim();
      notes.forEach(function (n) { n.hidden = isOther || (isEmpty && !!q); });
      topics.forEach(function (b) {
        var on = b.getAttribute('data-faq-topic') === state.group;
        b.classList.toggle('on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (window.SS && typeof SS.emit === 'function') SS.emit('wa:check', {});
    }

    function onClick(e) {
      var t = e.target && e.target.closest ? e.target : null;
      if (!t) return;
      var topic = t.closest('[data-faq-topic]');
      if (topic && root.contains(topic)) {
        state.group = topic.getAttribute('data-faq-topic');
        render();
        try { topic.scrollIntoView({ block: 'nearest', inline: 'nearest' }); } catch (err) {}
        return;
      }
      if (t.closest('[data-faq-clear]')) {
        state.query = '';
        state.group = 'all';
        if (input) { input.value = ''; input.focus(); }
        render();
        return;
      }
      if (t.closest('[data-faq-seeall]')) {
        state.group = 'all';
        render();
        var first = topics[0];
        if (first) first.focus();
        return;
      }
      var btn = t.closest('.acc-btn');
      if (btn && root.contains(btn)) {
        // core's accordion toggles on this click; record the result afterwards
        setTimeout(function () {
          state.open[btn.id] = btn.getAttribute('aria-expanded') === 'true';
        }, 0);
      }
    }

    function onInput() {
      state.query = input.value || '';
      render();
    }

    function onKey(e) {
      if (e.key === 'Escape' && input.value) {
        e.preventDefault();
        input.value = '';
        onInput();
      }
    }

    root.addEventListener('click', onClick);
    if (input) {
      input.addEventListener('input', onInput);
      input.addEventListener('keydown', onKey);
      if (input.value) { state.query = input.value; render(); }
    }

    return function destroy() {
      root.removeEventListener('click', onClick);
      if (input) {
        input.removeEventListener('input', onInput);
        input.removeEventListener('keydown', onKey);
      }
      root.__ssFaq = false;
    };
  }

  ready('page-faq', init);
})();
